<div class="row">
    <app-cybersocxmenu></app-cybersocxmenu>
</div>

<div class="col pb-2">
    <h1>{{ 'pages.dashboard.welcome' | translate }}</h1>
    <div class="row">
        <div class="col card p-3 me-2">
            <section class="pb-4">
                <h3 class="px-2 mb-0">{{ 'pages.cybersocxdr.dashboard.contracts' | translate }}</h3>
                <div class="dropdown-divider"></div>

                <p *ngIf="clientInfo.contract">
                    {{ 'pages.cybersocxdr.dashboard.dates' | translate }} :
                    <time [attr.datetime]="clientInfo.contract.startDate"> {{ clientInfo.contract.startDate | anonymise }}</time> --
                    <time [attr.datetime]="clientInfo.contract.endDate"> {{ clientInfo.contract.endDate | anonymise }}</time>
                </p>
            </section>

            <app-sladetails
                [slaInfo]="clientInfo.sla"
                [additionalInfo]="clientInfo.additionalInformation"
            ></app-sladetails>

            <section class="pb-4">
                <h3 class="px-2 mb-0">{{ 'pages.cybersocxdr.dashboard.fieldTitles.myAccess' | translate }}</h3>
                <div class="dropdown-divider"></div>

                <div class="row">
                    <a class="col text-center technoClient" target="_blank"  [attr.href]="'https://msurvey.orange.com/eXtendedSOC?tenant='+clientInfo.uuid">
                        <fa-icon [icon]="['fas', 'comment-sms']" size="xl" />                       
                        {{ 'pages.cybersocxdr.dashboard.feedback' | translate }}
                    </a>
                    <a class="col text-center technoClient" target="_blank" *ngFor="let techno of clientTechnologies" [attr.href]="techno.url">                    
                        <img src="{{techno.path}}" alt="">                        
                        {{techno.brand}}
                    </a>
                </div>
            </section>

            <section>
                <h3 class="px-2 mb-0">
                    {{ 'pages.cybersocxdr.dashboard.fieldTitles.clientSideContacts' | translate }}
                </h3>
                <div class="dropdown-divider"></div>

                <table style="table-layout: fixed" class="table table-hover text-center">
                    <caption class="d-none"> {{ 'pages.cybersocxdr.dashboard.fieldTitles.clientSideContacts' | translate }} </caption>
                    <thead>
                        <tr>
                            <th scope="col" class="py-1">
                                {{ 'pages.cybersocxdr.dashboard.fieldTitles.role' | translate }}
                            </th>
                            <th scope="col" class="py-1">
                                {{ 'pages.cybersocxdr.dashboard.fieldTitles.phoneNumber' | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let client of clientContactData">
                            <td>{{ client.role | anonymise }}</td>
                            <td><a [attr.href]="'tel:' + client.number">{{ client.number | anonymise }}</a></td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </div>

        <section class="col-xl-5 card p-3">
            <h3>{{ 'pages.cybersocxdr.dashboard.fieldTitles.ocdSideContacts' | translate }}</h3>
            <highcharts-chart
                [Highcharts]="highcharts"
                [options]="organizationOptions"
                style="width: 100%; height: 600px; display: block"
            ></highcharts-chart>
        </section>
    </div>
</div>
